export function normalizeClass(name: string): string {
    return name.toLowerCase()
        .replace('(', '')
        .replace(')', '')
        .replace(',', '')
        .replace(' ', '-')
        .replace(/\s/g, '-')
}